module.exports = __webpack_public_path__ + "img/otp-code.7a8a2da2.jpg";